import { BookmakerWhitelistIcon } from "../icons";
import Create from "./Create";
import List from "./List";

export default {
	options: {
		group: "bookmakers",
		roles: ["admin"],
	},
	icon: BookmakerWhitelistIcon,
	list: List,
	create: Create,
};
